import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Typography,
  FormControlLabel,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";

import { useMediaQuery, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import dayjs from "dayjs";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useLocation } from "react-router-dom";
import {
  updatepos,
  getAllItems,
  getCategories,
  fetchSubCategories,
  fetchItemsByCategoryAndSubcategory,
  GetApprovedSuppliers as fetchSuppliers,
  getUnits,
  ApproveSolistapi,
  postpos,
  GetNextPoNo,
  getSizes,
} from "../../../Services/Services";
import Autocomplete from "@mui/material/Autocomplete";
import { toast, ToastContainer } from "react-toastify";

import AddItemForm from "../Inventory/ItemForm";
import { useCallback } from "react";
import { debounce } from "lodash";
// vikas
export default function PurchaseOrderForm() {
  const stored = localStorage.getItem("selectedDivision");
  const division = JSON.parse(stored);

  const [formData, setFormData] = useState({
    po_number: "",
    supplier: "",
    division: division?.division_id || "",
    project: "",
    billing_name: "",
    billing_address: "",
    billing_pan: "",
    billing_gst: "",
    billing_division: division?.division_id || "",
    billing_email: "",
    billing_contact: "",
    // Billed To (Company Details)
    billed_to_name: "CRANOIST MATERIAL HANDLING EQUIPMENTS PVT. LTD.",
    billed_to_email: "info@cranoistmhe.com",
    billed_to_contact: "9825586999", // Added phone field
    billed_to_state_name: "Chattisgarh",
    billed_to_state_code: "22",
    billed_to_gst_no: "22AAECC0064F1ZC",
    billed_to_pan_no: "AAECC0064F",
    billed_to_address: "Shed No.6, Industrial Growth Center, Borai, Rasamada, Chhattisgarh 491001",
    // Shipping
    shipping_address: "",
    shipping_contact: "",
    shipping_phone: "",
    items: [
      {
        category: null,
        sub_category: null,
        item: null,
        description: "",
        quantity: 0,
        used_qty: 0,
        unit: "",
        unit_name: "",
        rate: "",
        amount: "",
        size: null,
      },
    ],
    created_by: localStorage.getItem("user_id"),
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [itemOptions, setItemOptions] = useState({});
  const [openItemModal, setOpenItemModal] = useState(false);
  const [subcategories, setSubcategories] = useState([]);
  const [categories, setCategories] = useState([]);
  const [includeShipping, setIncludeShipping] = useState(false);
  const [rowErrors, setRowErrors] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [sizeOptions, setSizeOptions] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [terms, setTerms] = useState([
    { key: "Delivery Period", value: "Ready stock", is_default: true },
    { key: "Warranty", value: "12 months from delivery", is_default: true },
    { key: "Freight", value: "Ex works. Raipur", is_default: true },
    { key: "Inspection", value: "By buyer at site", is_default: true },
    { key: "Quality", value: "As per specifications", is_default: true },
    {
      key: "Rejection/Claim",
      value: "Allowed within 7 days",
      is_default: true,
    },
    { key: "Jurisdiction", value: "Durg", is_default: true },
    {
      key: "Payment Terms",
      value: "Material received after 30 days",
      is_default: true,
    },
    { key: "GST", value: "18% applicable", is_default: true },
    { key: "Billing gst no-", value: division?.gst_no, is_default: true },
  ]);

  const [valueOptions, setValueOptions] = useState([
    "As per discussion",
    "Standard",
    "Mutually agreed",
  ]);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrors, setSubmitErrors] = useState({});
  const [itemFieldErrors, setItemFieldErrors] = useState([]);

  // Add Item
  const addItemRow = () => {
    setFormData((prev) => ({
      ...prev,
      items: [
        ...prev.items,
        {
          category: null,
          sub_category: null,
          item: null,
          description: "",
          quantity: 0,
          used_qty: 0,
          unit: "",
          unit_name: "",
          rate: "",
          amount: "",
          size: null,
        },
      ],
    }));
  };

  const totalValue = formData.items.reduce(
    (sum, item) => sum + parseFloat(item.amount || 0),
    0,
  );

  // Handle Field Change
  const handleItemChange = (index, field, value) => {
    const updatedItems = [...formData.items];
    updatedItems[index][field] = value;

    if (field === "quantity") {
      const q = parseFloat(value || 0);
      const used = parseFloat(updatedItems[index].used_qty);
    }

    const qty = parseFloat(updatedItems[index].quantity) || 0;
    const rate = parseFloat(updatedItems[index].rate) || 0;
    updatedItems[index].amount = (qty * rate).toFixed(2);

    // Clear error when user types
    if (itemFieldErrors[index] && itemFieldErrors[index][field]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index][field];
      if (Object.keys(newItemErrors[index]).length === 0) {
        delete newItemErrors[index];
      }
      setItemFieldErrors(newItemErrors);
    }

    setFormData((prev) => ({
      ...prev,
      items: updatedItems,
    }));
  };

  // Delete Row
  const deleteItemRow = (index) => {
    const updatedItems = formData.items.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, items: updatedItems }));

    // Remove errors for deleted row
    if (itemFieldErrors[index]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index];
      setItemFieldErrors(newItemErrors);
    }
  };

  const defaultLabels = [
    "Delivery Period",
    "Warranty",
    "Freight",
    "Inspection",
    "Quality",
    "Rejection/Claim",
    "Jurisdiction",
    "Payment Terms",
    "TCS/TDS",
    "Remark",
  ];

  const [suppliers, setSuppliers] = useState([]);
  const [supplierPage, setSupplierPage] = useState(1);
  const [supplierLoading, setSupplierLoading] = useState(false);
  const [supplierSearch, setSupplierSearch] = useState("");
  const [project, setProject] = useState([]);
  const [projectPage, setProjectPage] = useState(1);
  const [projectLoading, setProjectLoading] = useState(false);
  const [projectSearch, setProjectSearch] = useState("");
  const [divisions, setDivisions] = useState([]);
  const location = useLocation();

  const { poData, isEdit } = location.state || {};

  // ✅ MODIFIED: Removed division dependency
  const fetchProjects = async (page = 1, filters = {}) => {
    try {
      setProjectLoading(true);
      // Removed division filter completely
      const response = await ApproveSolistapi(page, filters);

      const results = Array.isArray(response.results)
        ? response.results
        : response || [];

      console.log(results);

      if (page === 1) {
        setProject(results);
      } else {
        setProject((prev) => [...prev, ...results]);
      }

      setProjectPage(page);
    } catch (err) {
      toast.error("Failed to load project list");
    } finally {
      setProjectLoading(false);
    }
  };

  // ✅ MODIFIED: No division check, fetch on mount and search change
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchProjects(1, { project_name: projectSearch });
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [projectSearch]);

  useEffect(() => {
    fetchProjects(1, {});
  }, []);

  const fetchSupplier = async (page = 1, filters = {}) => {
    try {
      setSupplierLoading(true);
      const response = await fetchSuppliers(page, filters);

      const results = Array.isArray(response.results)
        ? response.results
        : response || [];

      if (page === 1) {
        setSuppliers(results);
      } else {
        setSuppliers((prev) => [...prev, ...results]);
      }

      setSupplierPage(page);
    } catch (err) {
      toast.error("Failed to load project list");
    } finally {
      setSupplierLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      // Search filter trigger
      fetchSupplier(1, { name: supplierSearch });
    }, 500); // Wait 0.5s after typing stops

    return () => clearTimeout(delayDebounce);
  }, [supplierSearch]);

  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const catRes = await getCategories();
        const unitRes = await getUnits();
        const sizeRes = await getSizes();
        setCategories(Array.isArray(catRes) ? catRes : catRes?.results || []);
        setUnitOptions(unitRes);
        setSizeOptions(sizeRes);
      } catch (error) {}
    };

    if (isEdit && poData) {
      setFormData({
        ...formData,
        ...poData,
        created_by: localStorage.getItem("user_id"),
        billing_email: poData.billing_email || "",
        billing_contact: poData.billing_contact || "",
        billed_to_name: poData.billed_to_name || "CRANOIST MHE PVT. LTD.",
        billed_to_email: poData.billed_to_email || "info@cranoistmhe.com",
        billed_to_contact: poData.billed_to_contact || "9302122967",
        billed_to_state_name: poData.billed_to_state_name || "Chattisgarh",
        billed_to_state_code: poData.billed_to_state_code || "22",
        billed_to_gst_no: poData.billed_to_gst_no || division?.gst_no,
        billed_to_pan_no: poData.billed_to_pan_no || division?.pan_no,
        billed_to_address: poData.billed_to_address || division?.address,
        items: (poData.items || []).map((it) => ({
          ...it,
          category: it.category
            ? { id: it.category, name: it.category_name || "" }
            : null,
          sub_category: it.sub_category
            ? { subcat_id: it.sub_category, name: it.sub_category_name || "" }
            : null,
          item: it.item ? { id: it.item, name: it.item_name || "" } : null,
          unit: it.unit ?? it.uom ?? "",
          unit_name: it.unit_name ?? it.uom_name ?? "",
          description: it.description ?? it.item_name ?? "",
          rate: parseFloat(it.rate) || 0,
          quantity: parseFloat(it.quantity) || 0,
          amount: (
            (parseFloat(it.rate) || 0) * (parseFloat(it.quantity) || 0)
          ).toFixed(2),
        })),
      });
      setIncludeShipping(!!poData.shipping_address);
      setTerms(poData.terms_conditions || []);
    }

    const fetchItems = async () => {
      const data = await getAllItems();
      if (Array.isArray(data)) {
        setItemOptions(data);
      }
    };

    fetchItems();
    fetchDropdowns();
    getAllItems();

    if (!isEdit && !poData?.po_id) {
      fetchNextPoNo();
    }
  }, []);

  const fetchNextPoNo = async () => {
    const data = await GetNextPoNo();
    if (data && data.po_number) {
      setFormData((prev) => ({
        ...prev,
        po_number: data.po_number,
      }));
    }
  };

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    // Clear error when user starts typing
    if (submitErrors[field]) {
      setSubmitErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleTermChange = (index, field, value) => {
    const updatedTerms = [...terms];
    updatedTerms[index][field] = value;
    setTerms(updatedTerms);
  };

  const [errors, setErrors] = useState({
    billing_pan: "",
    billing_gst: "",
    billed_to_email: "",
    billed_to_contact: "",
    billed_to_pan_no: "",
    billed_to_gst_no: "",
    billing_email: "", // ✅ NEW FIELD
    billing_contact: "",
  });

  const validateField = (field, value) => {
    let error = "";

    if (field === "billing_pan") {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
      if (value && !panRegex.test(value.toUpperCase())) {
        error = "Invalid PAN format (eg. AAAPZ1234C)";
      }
    }

    if (field === "billing_email" || field === "billed_to_email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !emailRegex.test(value)) {
        error = "Invalid email format (e.g., example@domain.com)";
      }
    }

    // ✅ Contact/Phone Validation for all phone fields
    if (
      field === "billing_contact" ||
      field === "billed_to_contact" ||
      field === "shipping_phone"
    ) {
      const cleanValue = value.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const landlineRegex = /^0\d{10,11}$/;
      const internationalRegex = /^\+\d{10,14}$/;

      if (value && cleanValue.length > 0) {
        if (
          !phoneRegex.test(cleanValue) &&
          !landlineRegex.test(cleanValue) &&
          !internationalRegex.test(cleanValue)
        ) {
          error = "Invalid phone number";
        }
      }
    }

    if (field === "billing_gst") {
      const gstRegex =
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      if (value && !gstRegex.test(value.toUpperCase())) {
        error = "Invalid GSTIN format (eg. 27ABCDE1234F1Z5)";
      }
    }

    if (field === "billed_to_email") {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value && !emailRegex.test(value)) {
        error = "Invalid email format (e.g., example@domain.com)";
      }
    }

    // Contact/Phone Validation (Indian mobile number format)
    if (field === "billed_to_contact" || field === "shipping_phone") {
      // Remove spaces and dashes for validation
      const cleanValue = value.replace(/[\s-]/g, "");

      // Check if it's a valid phone number (10 digits starting with 6-9 for Indian numbers)
      const phoneRegex = /^[6-9]\d{9}$/;
      // Also allow landline numbers with STD code
      const landlineRegex = /^0\d{10,11}$/;
      // Allow international format
      const internationalRegex = /^\+\d{10,14}$/;

      if (value && cleanValue.length > 0) {
        if (
          !phoneRegex.test(cleanValue) &&
          !landlineRegex.test(cleanValue) &&
          !internationalRegex.test(cleanValue)
        ) {
          error = "Invalid phone number (e.g., 9876543210 or +919876543210)";
        }
      }
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return error; // ✅ <-- return the error
  };

  const handleChangeWithValidation = (field) => (e) => {
    let value = e.target.value;

    // Auto-uppercase for PAN and GST fields
    if (field.includes("pan") || field.includes("gst")) {
      value = value.toUpperCase();
    }

    // Update form data
    setFormData((prev) => ({ ...prev, [field]: value }));

    // Validate field in real-time
    validateField(field, value);

    // Clear submit errors when user starts typing
    if (submitErrors[field]) {
      setSubmitErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const handleCloseItemModal = async () => {
    setOpenItemModal(false);
  };

  // Improved validation function
  const validateForm = () => {
    const newErrors = {};
    const newItemErrors = [];

    // PO Details validation
    if (!formData.po_number) newErrors.po_number = "PO Number is required";
    // if (!formData.project) newErrors.project = "Project is required";

    // Billed From (Supplier) validation
    if (!formData.supplier) newErrors.supplier = "Supplier is required";
    if (!formData.billing_name)
      newErrors.billing_name = "Supplier Name is required";
    if (!formData.billing_address)
      newErrors.billing_address = "Supplier Address is required";

    // Billed To validation
    if (!formData.billed_to_name)
      newErrors.billed_to_name = "Company Name is required";
    if (!formData.billed_to_address)
      newErrors.billed_to_address = "Address is required";

    // Email validation for Billed To
    if (formData.billed_to_email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.billed_to_email)) {
        newErrors.billed_to_email = "Invalid email format";
      }
    }

    if (formData.billing_email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.billing_email)) {
        newErrors.billing_email = "Invalid email format";
      }
    }

    if (formData.billing_contact) {
      const cleanPhone = formData.billing_contact.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (
        !phoneRegex.test(cleanPhone) &&
        !internationalRegex.test(cleanPhone)
      ) {
        newErrors.billing_contact = "Invalid phone number format";
      }
    }

    // Phone validation for Billed To
    if (formData.billed_to_contact) {
      const cleanPhone = formData.billed_to_contact.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (
        !phoneRegex.test(cleanPhone) &&
        !internationalRegex.test(cleanPhone)
      ) {
        newErrors.billed_to_contact = "Invalid phone number format";
      }
    }

    // PAN validation for Billed From
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
    if (
      formData.billing_pan &&
      !panRegex.test(formData.billing_pan.toUpperCase())
    ) {
      newErrors.billing_pan = "Invalid PAN format";
    }

    // GST validation for Billed From
    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    if (
      formData.billing_gst &&
      !gstRegex.test(formData.billing_gst.toUpperCase())
    ) {
      newErrors.billing_gst = "Invalid GSTIN format";
    }

    // PAN validation for Billed To
    if (
      formData.billed_to_pan_no &&
      !panRegex.test(formData.billed_to_pan_no.toUpperCase())
    ) {
      newErrors.billed_to_pan_no = "Invalid PAN format";
    }

    // GST validation for Billed To
    if (
      formData.billed_to_gst_no &&
      !gstRegex.test(formData.billed_to_gst_no.toUpperCase())
    ) {
      newErrors.billed_to_gst_no = "Invalid GSTIN format";
    }

    // Shipping phone validation (if shipping is included)
    if (includeShipping && formData.shipping_phone) {
      const cleanPhone = formData.shipping_phone.replace(/[\s-]/g, "");
      const phoneRegex = /^[6-9]\d{9}$/;
      const internationalRegex = /^\+\d{10,14}$/;
      if (
        !phoneRegex.test(cleanPhone) &&
        !internationalRegex.test(cleanPhone)
      ) {
        newErrors.shipping_phone = "Invalid phone number format";
      }
    }

    // Items validation (same as before)
    if (formData.items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      formData.items.forEach((item, index) => {
        const itemError = {};
        let hasError = false;

        if (!item.category) {
          itemError.category = "Category is required";
          hasError = true;
        }
        // if (!item.sub_category) {
        //   itemError.sub_category = "Sub Category is required";
        //   hasError = true;
        // }
        if (!item.item) {
          itemError.item = "Item is required";
          hasError = true;
        }
        if (!item.quantity || parseFloat(item.quantity) <= 0) {
          itemError.quantity = "Valid quantity is required";
          hasError = true;
        }
        if (!item.unit) {
          itemError.unit = "Unit is required";
          hasError = true;
        }
        if (!item.rate || parseFloat(item.rate) < 0) {
          itemError.rate = "Valid rate is required";
          hasError = true;
        }

        if (hasError) {
          newItemErrors[index] = itemError;
        }
      });
    }

    return { fieldErrors: newErrors, itemErrors: newItemErrors };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Don't submit if already submitting
    if (isSubmitting) {
      toast.warn("Please wait, form is already submitting...");
      return;
    }

    // Reset errors
    setSubmitErrors({});
    setItemFieldErrors([]);

    // Validate form
    const validation = validateForm();

    if (
      Object.keys(validation.fieldErrors).length > 0 ||
      validation.itemErrors.length > 0
    ) {
      setSubmitErrors(validation.fieldErrors);
      setItemFieldErrors(validation.itemErrors);

      // Scroll to first error
      setTimeout(() => {
        const firstErrorElement =
          document.querySelector("[error]") ||
          document.querySelector(".Mui-error") ||
          document.querySelector('input[style*="border: 1px solid red"]');
        if (firstErrorElement) {
          firstErrorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);

      toast.error("Please fix all validation errors before submitting");
      return;
    }

    setIsSubmitting(true);

    try {
      // Prepare payload
      const filteredTerms = terms.filter(
        (term) => term.key?.trim() !== "" && term.value?.trim() !== "",
      );

      const cleanedItems = formData.items.map((item) => ({
        ...item,
        // Extract category ID
        category: item.category?.id || item.category || null,
        // Extract sub_category ID
        sub_category: item.sub_category?.subcat_id || item.sub_category || null,
        // Extract item ID
        item: item.item?.id || item.item || null,
        // ✅ FIX: Extract size ID (was sending object, now sending just ID)
        size:
          typeof item.size === "object"
            ? item.size?.id || null
            : item.size || null,
        // ✅ FIX: Extract unit ID (ensure it's just the ID)
        unit:
          typeof item.unit === "object"
            ? item.unit?.id || null
            : item.unit || null,
        // Ensure numeric values
        quantity: parseFloat(item.quantity) || 0,
        rate: parseFloat(item.rate) || 0,
        amount: parseFloat(item.amount) || 0,
        // Keep other fields
        description: item.description || "",
        used_qty: parseFloat(item.used_qty) || 0,
      }));

      const payload = {
        ...formData,
        items: cleanedItems,
        include_shipping: includeShipping,
        terms_conditions: filteredTerms,
        quotation_date: formData.quotation_date
          ? dayjs(formData.quotation_date).format("YYYY-MM-DD")
          : null,
      };

      console.log("Payload being sent:", JSON.stringify(payload, null, 2)); // Debug log

      let response;
      if (isEdit && poData?.po_id) {
        response = await updatepos(poData.po_id, payload);
        toast.success("Purchase Order updated successfully!");
        setTimeout(() => {
          navigate("/dashboard/po-list");
        }, 1500);
      } else {
        response = await postpos(payload);
        toast.success("Purchase Order created successfully!");
        setTimeout(() => {
          navigate("/dashboard/po-list");
        }, 1500);
      }
    } catch (err) {
      console.error("Submit error:", err);

      let errorMessage = "Failed to submit Purchase Order";
      if (err.response) {
        // Server responded with error status
        if (err.response.data) {
          if (typeof err.response.data === "object") {
            errorMessage = Object.values(err.response.data).flat().join(", ");
          } else {
            errorMessage = err.response.data;
          }
        }
        toast.error(errorMessage);
      } else if (err.request) {
        // Request was made but no response
        toast.error("No response from server. Please check your connection.");
      } else {
        // Something else happened
        toast.error(errorMessage);
      }

      // Don't navigate on error
      setIsSubmitting(false);
      return;
    } finally {
      if (!isEdit) {
        setFormData({
          po_number: formData.po_number,
          supplier: "",
          division: "",
          project: "",
          billing_name: "",
          billing_address: "",
          billing_pan: "",
          billing_gst: "",
          billing_division: division?.division_id || "",
          billing_email: "",
          billing_contact: "",
          billed_to_name: "",
          billed_to_email: "",
          billed_to_state_name: "",
          billed_to_state_code: "",
          billed_to_gst_no: "",
          billed_to_pan_no: "",
          billed_to_address: "",
          // Shipping
          shipping_address: "",
          shipping_contact: "",
          shipping_phone: "",
          items: [
            {
              category: null,
              sub_category: null,
              item: null,
              description: "",
              quantity: 0,
              used_qty: 0,
              unit: "",
              unit_name: "",
              rate: "",
              amount: "",
              size: null,
            },
          ],
          created_by: localStorage.getItem("user_id"),
        });
        setTerms(
          defaultLabels.map((label) => ({
            key: label,
            value: terms.find((t) => t.key === label)?.value || "",
            is_default: true,
          })),
        );
        setIncludeShipping(false);
      }
    }
  };

  const removeTerm = (index) => {
    const updatedTerms = terms.filter((_, i) => i !== index);
    setTerms(updatedTerms);
  };

  const inputStyle = {
    width: "100%", // stretch to full cell width
    padding: "8px", // similar to MUI spacing
    fontSize: "0.875rem", // same as MUI's small TextField
    backgroundColor: "#ffffff", // pure white like MUI's default
    border: "1px solid #c4c4c4", // subtle grey like MUI
    borderRadius: "4px", // rounded corners
    boxSizing: "border-box",
  };

  useEffect(() => {
    if (!isEdit) return;
    const rows = formData.items || [];
    if (rows.length === 0) return;

    let cancel = false;

    (async () => {
      const subs = [];
      const itemsMap = {};
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];

        if (r?.category?.id) {
          // const subcatData = await fetchSubCategories(r.category.id);
          // subs[i] = subcatData || [];

          if (r?.category?.id) {
            const itemData = await fetchItemsByCategoryAndSubcategory(
              r.category.id,
              0,
            );
            itemsMap[i] = (itemData?.results || []).map((x) => ({
              id: x.id,
              name: x.name,
            }));
          }
        }
      }

      if (!cancel) {
        setSubcategories(subs);
        setItemOptions(itemsMap);
      }
    })();

    return () => {
      cancel = true;
    };
  }, [isEdit, formData.items]);

  const handleInputChange = async (index, key, value) => {
    const updatedRows = [...formData.items];
    let row = { ...updatedRows[index] };

    // Clear item field error when user makes selection
    if (itemFieldErrors[index] && itemFieldErrors[index][key]) {
      const newItemErrors = [...itemFieldErrors];
      delete newItemErrors[index][key];
      if (Object.keys(newItemErrors[index]).length === 0) {
        delete newItemErrors[index];
      }
      setItemFieldErrors(newItemErrors);
    }

    switch (key) {
      case "category":
        row = {
          ...row,
          category: value,
          sub_category: null,
          item: null,
          description: "",
          unit: "",
          unit_name: "",
          rate: "",
          amount: "",
          size: null,
        };
        if (value && value.id) {
          // ✅ Fetch items directly by category ID (without subcategory)
          const itemData = await fetchItemsByCategoryAndSubcategory(
            value.id,
            0, // subcategory = 0 ya null
            page,
            searchTerm
          );
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
            item_code: item.item_code || item.code || "",
            unit_id: item.unit || item.uom || null,
            unit_name: item.unit_name || item.uom_name || "",
            size_id: item.size || null,
            size_name: item.size_name || "",
            rate: item.rate || item.unit_price || 0,
            description: item.description || item.item_description || "",
            current_stock: item.current_stock || 0,
          }));
          setItemOptions((prev) => ({ ...prev, [index]: mappedItems }));
        } else {
          setItemOptions((prev) => ({ ...prev, [index]: [] }));
        }
        break;

      case "item":
        // ✅ CRITICAL FIX: Category ko preserve karo, sirf item fields update karo
        const selectedItem = value;
        if (selectedItem) {
          let foundUnit = selectedItem?.unit_id || "";
          let foundUnitName = selectedItem?.unit_name || "";
          if (selectedItem?.unit_id) {
            const unitObj = unitOptions.find(
              (u) => String(u.id) === String(selectedItem.unit_id)
            );
            if (unitObj) {
              foundUnit = unitObj.id;
              foundUnitName = unitObj.name || unitObj.unit_name || "";
            }
          }
          let foundSize = null;
          if (selectedItem?.size_id) {
            foundSize = sizeOptions.find(
              (s) => String(s.id) === String(selectedItem.size_id)
            ) || null;
          }
          // ✅ Row ke existing category, sub_category ko change mat karo
          row = {
            ...row,
            item: selectedItem,
            description: selectedItem?.description || selectedItem?.name || "",
            rate: selectedItem?.rate || selectedItem?.price || "",
            unit: foundUnit,
            unit_name: foundUnitName,
            size: foundSize,
          };
          // Recalculate amount
          const qty = parseFloat(row.quantity) || 0;
          const rate = parseFloat(row.rate) || 0;
          row.amount = (qty * rate).toFixed(2);
        } else {
          row = { ...row, item: null, description: "", rate: "", amount: "" };
        }
        break;

      case "size":
        row = { ...row, size: value };
        break;

      case "unit":
        if (value && typeof value === "object") {
          row = {
            ...row,
            unit: value.id || "",
            unit_name: value.name || value.unit_name || "",
          };
        } else {
          row = { ...row, unit: value || "", unit_name: "" };
        }
        break;

      case "quantity":
      case "rate":
        row = { ...row, [key]: value };
        const newQty = parseFloat(key === "quantity" ? value : row.quantity) || 0;
        const newRate = parseFloat(key === "rate" ? value : row.rate) || 0;
        row.amount = (newQty * newRate).toFixed(2);
        break;

      default:
        row = { ...row, [key]: value };
    }

    updatedRows[index] = row;
    setFormData((prev) => ({ ...prev, items: updatedRows }));
  };

  // 1️⃣ Top level me define karo
  const handleItemInputChange = useCallback(
    debounce(async (index, row, newValue, type) => {
      if (!newValue || newValue.trim() === "") {
        if (type === "category") {
          const catData = await getCategories();
          const list = Array.isArray(catData.results)
            ? catData.results
            : catData;
          setCategories(list);
        }

        if (type === "sub_category" && row.category) {
          const subcatData = await fetchSubCategories(row.category.id);
          setSubcategories((prev) => {
            const updated = [...prev];
            updated[index] = subcatData;
            return updated;
          });
        }

        if (type === "item" && row.category) {
          const itemData = await fetchItemsByCategoryAndSubcategory(
            row.category.id,
            0,
          );
          const mappedItems = (itemData.results || []).map((item) => ({
            id: item.id,
            name: item.name,
            item_code: item.item_code || item.code || "",
            unit_id: item.unit || item.uom || null,
            unit_name: item.unit_name || item.uom_name || "",
            size_id: item.size || null,
            size_name: item.size_name || "",
            rate: item.rate || item.unit_price || 0,
            description: item.description || item.item_description || "",
            current_stock: item.current_stock || 0,
          }));
          setItemOptions((prev) => ({
            ...prev,
            [index]: mappedItems,
          }));
        }

        if (type === "size") {
          const sizeData = await getSizes();
          const list = Array.isArray(sizeData.results)
            ? sizeData.results
            : sizeData;
          setSizeOptions(list);
        }

        return;
      }

      if (type === "category") {
        const catData = await getCategories(1, newValue || "");
        const list = Array.isArray(catData.results) ? catData.results : catData;
        setCategories(list);
      }

      if (type === "sub_category" && row.category) {
        const subcatData = await fetchSubCategories(
          row.category.id,
          1,
          newValue || "",
        );
        setSubcategories((prev) => {
          const updated = [...prev];
          updated[index] = subcatData;
          return updated;
        });
      }

      if (type === "item" && row.category) {
        const itemData = await fetchItemsByCategoryAndSubcategory(
          row.category.id,
          0,
          1,
          newValue || "",
        );

        const mappedItems = (itemData.results || []).map((item) => ({
          id: item.id,
          name: item.name,
          item_code: item.item_code || item.code || "",
          unit_id: item.unit || item.uom || null,
          unit_name: item.unit_name || item.uom_name || "",
          size_id: item.size || null,
          size_name: item.size_name || "",
          rate: item.rate || item.unit_price || 0,
          description: item.description || item.item_description || "",
          current_stock: item.current_stock || 0,
        }));

        setItemOptions((prev) => ({
          ...prev,
          [index]: mappedItems,
        }));
      }

      if (type === "size") {
        const sizeData = await getSizes(newValue || "");
        const list = Array.isArray(sizeData.results)
          ? sizeData.results
          : sizeData;
        setSizeOptions(list);
      }
    }, 500),
    [sizeOptions],
  );

  const handleSaveDraft = () => {
    sessionStorage.setItem("poDraft", JSON.stringify(formData));
    sessionStorage.setItem("poTerms", JSON.stringify(terms));
    toast.info("Purchase Order draft saved!");
  };

  useEffect(() => {
    const draftForm = sessionStorage.getItem("poDraft");
    const draftTerms = sessionStorage.getItem("poTerms");
    if (draftForm) {
      try {
        setFormData(JSON.parse(draftForm));
        if (draftTerms) setTerms(JSON.parse(draftTerms));
        toast.info("Loaded Purchase Order draft");
      } catch (e) {}
    }
  }, []);

  return (
    <Box sx={{ px: 0, pt: 0, mt: -3, maxWidth: 1200, mx: "auto" }}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />

      {/* 🔹 MOBILE VIEW - Buttons at Top */}

      <Box
        sx={{
          display: "flex",
          justifyContent: "right",
          alignItems: "center",
          mb: 3,
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? 2 : 0,
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: isMobile ? "column" : "row",
            width: isMobile ? "100%" : "auto",
          }}
        >
          <Button
            type="button"
            variant="outlined"
            onClick={handleSaveDraft}
            fullWidth={isMobile}
            sx={{
              height: 40,
              fontSize: "0.875rem",
              color: "#ff8400ff",
              borderColor: "#ff8400ff",
              fontWeight: 500,
              textTransform: "none",
              minWidth: 120,
              borderRadius: 0,
              "&:hover": {
                borderColor: "#e67600",
                backgroundColor: "rgba(255, 132, 0, 0.04)",
              },
            }}
          >
            Save Draft
          </Button>
          <Button
            type="button"
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={isSubmitting}
            fullWidth={isMobile}
            sx={{
              height: 40,
              fontSize: "0.875rem",
              fontWeight: 600,
              textTransform: "none",
              minWidth: 180,
              borderRadius: 0,
            }}
          >
            {isSubmitting ? "Submitting..." : "Submit Purchase Order"}
          </Button>
        </Box>
      </Box>

      <Box
        border="1px solid #ccc"
        borderRadius="8px"
        sx={{ mb: 3, p: isMobile ? 1.5 : 2 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="PO Number"
              required
              value={formData.po_number || ""}
              onChange={handleChange("po_number")}
              error={!!submitErrors.po_number}
              helperText={submitErrors.po_number}
              disabled
              InputProps={{
                sx: {
                  height: 45,
                  fontSize: "0.875rem",
                  borderRadius: 1,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Autocomplete
              options={Array.isArray(project) ? project : []}
              required
              getOptionLabel={(option) =>
                option?.project_name || `Project ${option?.id}` || ""
              }
              value={
                Array.isArray(project) && formData.project
                  ? project.find((i) => i.id === formData.project) || null
                  : null
              }
              loading={projectLoading}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              onChange={(e, newValue) => {
                if (newValue) {
                  setFormData((prev) => ({
                    ...prev,
                    project: newValue.id,
                    billing_email: newValue.email || "",
                    billing_contact: newValue.contact || newValue.phone || "",
                  }));
                } else {
                  setFormData((prev) => ({
                    ...prev,
                    project: "",
                    billing_email: "",
                    billing_contact: "",
                  }));
                }
                if (submitErrors.project) {
                  setSubmitErrors((prev) => ({ ...prev, project: "" }));
                }
              }}
              onInputChange={(e, newInputValue, reason) => {
                if (reason === "input") {
                  setProjectSearch(newInputValue);
                }
              }}
              noOptionsText="No projects found"
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Project"
                  fullWidth
                  error={!!submitErrors.project}
                  helperText={submitErrors.project}
                  InputProps={{
                    ...params.InputProps,
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>

      {/* ========== BILLED FROM & BILLED TO - SIDE BY SIDE ========== */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <Box
            border="1px solid #ccc"
            borderRadius="8px"
            sx={{ p: isMobile ? 1.5 : 2, height: "100%" }}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              Billed From
            </Typography>

            <Grid container spacing={2}>
              {/* Supplier Autocomplete */}
              <Grid item xs={12}>
                <Autocomplete
                  options={suppliers}
                  required
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    (Array.isArray(suppliers) &&
                      suppliers.find((s) => s.id === formData.supplier)) ||
                    null
                  }
                  loading={supplierLoading}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value?.id
                  }
                  onChange={(e, newValue) => {
                    if (newValue) {
                      // ✅ Auto-populate all fields from supplier data
                      setFormData((prev) => ({
                        ...prev,
                        supplier: newValue.id,
                        billing_name: newValue.name || "",
                        billing_address: newValue.address || "",
                        billing_pan: newValue.pan || "",
                        billing_gst: newValue.gst || "",
                        billing_email: newValue.email || "", // ✅ From supplier.email
                        billing_contact: newValue.contact || "", // ✅ From supplier.contact
                      }));

                      // Clear any existing errors for these fields
                      setErrors((prev) => ({
                        ...prev,
                        billing_email: "",
                        billing_contact: "",
                        billing_pan: "",
                        billing_gst: "",
                      }));
                    } else {
                      // Clear all fields when supplier is deselected
                      setFormData((prev) => ({
                        ...prev,
                        supplier: "",
                        billing_name: "",
                        billing_address: "",
                        billing_pan: "",
                        billing_gst: "",
                        billing_email: "",
                        billing_contact: "",
                      }));
                    }
                    if (submitErrors.supplier) {
                      setSubmitErrors((prev) => ({ ...prev, supplier: "" }));
                    }
                  }}
                  onInputChange={(e, newInputValue) => {
                    setSupplierSearch(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select Supplier"
                      fullWidth
                      error={!!submitErrors.supplier}
                      helperText={submitErrors.supplier}
                      InputProps={{
                        ...params.InputProps,
                        sx: {
                          height: 45,
                          fontSize: "0.875rem",
                          borderRadius: 1,
                        },
                      }}
                    />
                  )}
                />
              </Grid>

              {/* Supplier Name */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Supplier Name"
                  required
                  value={formData.billing_name || ""}
                  onChange={handleChange("billing_name")}
                  error={!!submitErrors.billing_name}
                  helperText={submitErrors.billing_name}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              </Grid>

              {/* ✅ Email Field - Auto-populated from supplier.email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={formData.billing_email || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      billing_email: value,
                    }));

                    // Real-time email validation
                    const emailRegex =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (value && !emailRegex.test(value)) {
                      setErrors((prev) => ({
                        ...prev,
                        billing_email: "Invalid email format",
                      }));
                    } else {
                      setErrors((prev) => ({ ...prev, billing_email: "" }));
                    }

                    // Clear submit error
                    if (submitErrors.billing_email) {
                      setSubmitErrors((prev) => ({
                        ...prev,
                        billing_email: "",
                      }));
                    }
                  }}
                  error={!!errors.billing_email || !!submitErrors.billing_email}
                  helperText={
                    errors.billing_email || submitErrors.billing_email
                  }
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              </Grid>

              {/* ✅ Contact Field - Auto-populated from supplier.contact */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Contact"
                  value={formData.billing_contact || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Only allow numbers, +, spaces, and dashes
                    const sanitizedValue = value.replace(/[^0-9+\s-]/g, "");
                    setFormData((prev) => ({
                      ...prev,
                      billing_contact: sanitizedValue,
                    }));

                    // Real-time phone validation
                    const cleanValue = sanitizedValue.replace(/[\s-]/g, "");
                    const phoneRegex = /^[6-9]\d{9}$/;
                    const internationalRegex = /^\+\d{10,14}$/;

                    if (cleanValue.length > 0 && cleanValue.length < 10) {
                      setErrors((prev) => ({
                        ...prev,
                        billing_contact:
                          "Phone number must be at least 10 digits",
                      }));
                    } else if (
                      cleanValue.length >= 10 &&
                      !phoneRegex.test(cleanValue) &&
                      !internationalRegex.test(cleanValue)
                    ) {
                      setErrors((prev) => ({
                        ...prev,
                        billing_contact: "Invalid phone number format",
                      }));
                    } else {
                      setErrors((prev) => ({ ...prev, billing_contact: "" }));
                    }

                    // Clear submit error
                    if (submitErrors.billing_contact) {
                      setSubmitErrors((prev) => ({
                        ...prev,
                        billing_contact: "",
                      }));
                    }
                  }}
                  error={
                    !!errors.billing_contact || !!submitErrors.billing_contact
                  }
                  helperText={
                    errors.billing_contact || submitErrors.billing_contact
                  }
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 15,
                  }}
                />
              </Grid>

              {/* Supplier Address */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Supplier Address"
                  required
                  multiline
                  rows={2}
                  value={formData.billing_address || ""}
                  onChange={handleChange("billing_address")}
                  error={!!submitErrors.billing_address}
                  helperText={submitErrors.billing_address}
                />
              </Grid>

              {/* PAN */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="PAN"
                  value={formData.billing_pan || ""}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    setFormData({ ...formData, billing_pan: value });
                    validateField("billing_pan", value);
                    if (submitErrors.billing_pan) {
                      setSubmitErrors((prev) => ({ ...prev, billing_pan: "" }));
                    }
                  }}
                  error={!!errors.billing_pan || !!submitErrors.billing_pan}
                  helperText={errors.billing_pan || submitErrors.billing_pan}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </Grid>

              {/* GST */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="GST"
                  value={formData.billing_gst || ""}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    setFormData({ ...formData, billing_gst: value });
                    validateField("billing_gst", value);
                    if (submitErrors.billing_gst) {
                      setSubmitErrors((prev) => ({ ...prev, billing_gst: "" }));
                    }
                  }}
                  error={!!errors.billing_gst || !!submitErrors.billing_gst}
                  helperText={errors.billing_gst || submitErrors.billing_gst}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 15,
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>

        {/* ========== BILLED TO (Company Details) ========== */}
        <Grid item xs={12} md={6}>
          <Box
            border="1px solid #ccc"
            borderRadius="8px"
            sx={{ p: isMobile ? 1.5 : 2, height: "100%" }}
          >
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
              Billed To
            </Typography>

            <Grid container spacing={2}>
              {/* Company Name */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Company Name"
                  required
                  value={formData.billed_to_name || ""}
                  onChange={handleChange("billed_to_name")}
                  error={!!submitErrors.billed_to_name}
                  helperText={submitErrors.billed_to_name}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              </Grid>

              {/* Email with Real-time Validation */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  type="email"
                  value={formData.billed_to_email || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    setFormData((prev) => ({
                      ...prev,
                      billed_to_email: value,
                    }));

                    // Real-time email validation
                    const emailRegex =
                      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                    if (value && !emailRegex.test(value)) {
                      setErrors((prev) => ({
                        ...prev,
                        billed_to_email: "Invalid email format",
                      }));
                    } else {
                      setErrors((prev) => ({ ...prev, billed_to_email: "" }));
                    }

                    // Clear submit error
                    if (submitErrors.billed_to_email) {
                      setSubmitErrors((prev) => ({
                        ...prev,
                        billed_to_email: "",
                      }));
                    }
                  }}
                  error={
                    !!errors.billed_to_email || !!submitErrors.billed_to_email
                  }
                  helperText={
                    errors.billed_to_email || submitErrors.billed_to_email
                  }
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              </Grid>

              {/* Phone with Real-time Validation */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone"
                  value={formData.billed_to_contact || ""}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Only allow numbers, +, spaces, and dashes
                    const sanitizedValue = value.replace(/[^0-9+\s-]/g, "");
                    setFormData((prev) => ({
                      ...prev,
                      billed_to_contact: sanitizedValue,
                    }));

                    // Real-time phone validation
                    const cleanValue = sanitizedValue.replace(/[\s-]/g, "");
                    const phoneRegex = /^[6-9]\d{9}$/;
                    const internationalRegex = /^\+\d{10,14}$/;

                    if (cleanValue.length > 0 && cleanValue.length < 10) {
                      setErrors((prev) => ({
                        ...prev,
                        billed_to_contact:
                          "Phone number must be at least 10 digits",
                      }));
                    } else if (
                      cleanValue.length >= 10 &&
                      !phoneRegex.test(cleanValue) &&
                      !internationalRegex.test(cleanValue)
                    ) {
                      setErrors((prev) => ({
                        ...prev,
                        billed_to_contact: "Invalid phone number format",
                      }));
                    } else {
                      setErrors((prev) => ({ ...prev, billed_to_contact: "" }));
                    }
                  }}
                  error={!!errors.billed_to_contact}
                  helperText={errors.billed_to_contact}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 15,
                  }}
                />
              </Grid>

              {/* State Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="State Name"
                  value={formData.billed_to_state_name || ""}
                  onChange={handleChange("billed_to_state_name")}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                />
              </Grid>

              {/* State Code */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="State Code"
                  value={formData.billed_to_state_code || ""}
                  onChange={(e) => {
                    // Only allow numbers for state code
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    setFormData((prev) => ({
                      ...prev,
                      billed_to_state_code: value,
                    }));
                  }}
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 2,
                  }}
                />
              </Grid>

              {/* GST No with Real-time Validation */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="GST No"
                  value={formData.billed_to_gst_no || ""}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    setFormData((prev) => ({
                      ...prev,
                      billed_to_gst_no: value,
                    }));

                    // Real-time GST validation
                    const gstRegex =
                      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
                    if (value && value.length > 0) {
                      if (value.length < 15) {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_gst_no: "GST number must be 15 characters",
                        }));
                      } else if (!gstRegex.test(value)) {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_gst_no: "Invalid GSTIN format",
                        }));
                      } else {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_gst_no: "",
                        }));
                      }
                    } else {
                      setErrors((prev) => ({ ...prev, billed_to_gst_no: "" }));
                    }

                    if (submitErrors.billed_to_gst_no) {
                      setSubmitErrors((prev) => ({
                        ...prev,
                        billed_to_gst_no: "",
                      }));
                    }
                  }}
                  error={
                    !!errors.billed_to_gst_no || !!submitErrors.billed_to_gst_no
                  }
                  helperText={
                    errors.billed_to_gst_no || submitErrors.billed_to_gst_no
                  }
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 15,
                  }}
                />
              </Grid>

              {/* PAN No with Real-time Validation */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="PAN No"
                  value={formData.billed_to_pan_no || ""}
                  onChange={(e) => {
                    const value = e.target.value.toUpperCase();
                    setFormData((prev) => ({
                      ...prev,
                      billed_to_pan_no: value,
                    }));

                    // Real-time PAN validation
                    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
                    if (value && value.length > 0) {
                      if (value.length < 10) {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_pan_no: "PAN must be 10 characters",
                        }));
                      } else if (!panRegex.test(value)) {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_pan_no:
                            "Invalid PAN format (e.g., AAAPZ1234C)",
                        }));
                      } else {
                        setErrors((prev) => ({
                          ...prev,
                          billed_to_pan_no: "",
                        }));
                      }
                    } else {
                      setErrors((prev) => ({ ...prev, billed_to_pan_no: "" }));
                    }

                    if (submitErrors.billed_to_pan_no) {
                      setSubmitErrors((prev) => ({
                        ...prev,
                        billed_to_pan_no: "",
                      }));
                    }
                  }}
                  error={
                    !!errors.billed_to_pan_no || !!submitErrors.billed_to_pan_no
                  }
                  helperText={
                    errors.billed_to_pan_no || submitErrors.billed_to_pan_no
                  }
                  InputProps={{
                    sx: {
                      height: 45,
                      fontSize: "0.875rem",
                      borderRadius: 1,
                    },
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                />
              </Grid>

              {/* Address */}
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Address"
                  required
                  multiline
                  rows={2}
                  value={formData.billed_to_address || ""}
                  onChange={handleChange("billed_to_address")}
                  error={!!submitErrors.billed_to_address}
                  helperText={submitErrors.billed_to_address}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      {/* Shipping */}
      <Box sx={{ mb: 3 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeShipping}
              onChange={(e) => setIncludeShipping(e.target.checked)}
            />
          }
          label="Include Shipping Details"
        />
        {includeShipping && (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Shipping Address"
                value={formData.shipping_address || ""}
                onChange={handleChange("shipping_address")}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Contact Person"
                value={formData.shipping_contact || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  setFormData((prev) => ({ ...prev, shipping_contact: value }));
                  // Validate contact person name
                  if (value && !/^[a-zA-Z\s.'-]*$/.test(value)) {
                    setErrors((prev) => ({
                      ...prev,
                      shipping_contact: "Only letters and spaces allowed",
                    }));
                  } else {
                    setErrors((prev) => ({ ...prev, shipping_contact: "" }));
                  }
                }}
                error={!!errors.shipping_contact}
                helperText={errors.shipping_contact}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Phone"
                value={formData.shipping_phone || ""}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9+\s-]/g, "");
                  setFormData((prev) => ({ ...prev, shipping_phone: value }));

                  // Real-time phone validation
                  const cleanValue = value.replace(/[\s-]/g, "");
                  const phoneRegex = /^[6-9]\d{9}$/;
                  const internationalRegex = /^\+\d{10,14}$/;

                  if (cleanValue.length > 0 && cleanValue.length < 10) {
                    setErrors((prev) => ({
                      ...prev,
                      shipping_phone: "Phone number must be at least 10 digits",
                    }));
                  } else if (
                    cleanValue.length >= 10 &&
                    !phoneRegex.test(cleanValue) &&
                    !internationalRegex.test(cleanValue)
                  ) {
                    setErrors((prev) => ({
                      ...prev,
                      shipping_phone: "Invalid phone number format",
                    }));
                  } else {
                    setErrors((prev) => ({ ...prev, shipping_phone: "" }));
                  }
                }}
                error={!!errors.shipping_phone || !!submitErrors.shipping_phone}
                helperText={
                  errors.shipping_phone || submitErrors.shipping_phone
                }
                inputProps={{
                  maxLength: 15,
                }}
              />
            </Grid>
          </Grid>
        )}
      </Box>

      {/* Items Section with Error Display */}
      {submitErrors.items && (
        <Box
          sx={{
            mb: 2,
            p: 2,
            bgcolor: "#fff3cd",
            border: "1px solid #ffeaa7",
            borderRadius: 1,
          }}
        >
          <Typography color="error" variant="body2">
            {submitErrors.items}
          </Typography>
        </Box>
      )}

      {/* Quotation & Items */}
      {isMobile ? (
        // ✅ MOBILE VIEW - Vertical Cards
        <Box sx={{ mt: 2 }}>
          {formData.items.map((item, index) => (
            <Box
              key={index}
              sx={{
                mb: 3,
                p: 2,
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "#fafafa",
                borderColor: itemFieldErrors[index] ? "error.main" : "#ccc",
              }}
            >
              {/* Header with S.No and Delete */}
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
              >
                <strong>Item #{index + 1}</strong>
                <IconButton
                  onClick={() => deleteItemRow(index)}
                  color="error"
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* Category */}
              <Autocomplete
                options={Array.isArray(categories) ? categories : categories}
                getOptionLabel={(opt) => opt.name}
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                value={item.category || null}
                onChange={async (e, val, reason) => {
                  if (reason === "clear" || !val) {
                    await handleItemInputChange(index, item, "", "category");
                    handleInputChange(index, "category", null);
                    return;
                  }
                  handleInputChange(index, "category", val);
                }}
                onInputChange={(e, newValue, reason) => {
                  if (reason === "input") {
                    handleItemInputChange(index, item, newValue, "category");
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category"
                    size="small"
                    fullWidth
                    required
                    error={!!itemFieldErrors[index]?.category}
                    helperText={itemFieldErrors[index]?.category}
                    sx={{ mb: 2 }}
                  />
                )}
              />

              {/* Sub Category */}
              {/* <Autocomplete
                options={subcategories[index] || []}
                getOptionLabel={(opt) => opt.name}
                isOptionEqualToValue={(opt, val) =>
                  opt?.subcat_id === val?.subcat_id
                }
                value={
                  (subcategories[index] || []).find(
                    (s) => s.subcat_id === item.sub_category?.subcat_id,
                  ) || null
                }
                onChange={async (e, val, reason) => {
                  if (reason === "clear" || !val) {
                    await handleItemInputChange(
                      index,
                      item,
                      "",
                      "sub_category",
                    );
                    handleInputChange(index, "sub_category", null);
                    return;
                  }
                  handleInputChange(index, "sub_category", val);
                }}
                onInputChange={(e, newValue) =>
                  handleItemInputChange(index, item, newValue, "sub_category")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    label="Subcategory"
                    required
                    error={!!itemFieldErrors[index]?.sub_category}
                    helperText={itemFieldErrors[index]?.sub_category}
                    sx={{ mb: 2 }}
                  />
                )}
              /> */}

              {/* Item */}
              <Autocomplete
                options={
                  Array.isArray(itemOptions[index]) ? itemOptions[index] : []
                }
                getOptionLabel={(opt) => opt.name}
                isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                value={item.item}
                onChange={async (e, val, reason) => {
                  if (reason === "clear" || !val) {
                    await handleItemInputChange(index, item, "", "item");
                    handleInputChange(index, "item", null);
                    return;
                  }
                  handleInputChange(index, "item", val);
                }}
                onInputChange={(e, newValue) =>
                  handleItemInputChange(index, item, newValue, "item")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    label="Item"
                    required
                    error={!!itemFieldErrors[index]?.item}
                    helperText={itemFieldErrors[index]?.item}
                    sx={{ mb: 2 }}
                  />
                )}
              />

              {/* Description */}
              <TextField
                label="Description"
                fullWidth
                size="small"
                value={item.description}
                onChange={(e) =>
                  handleItemChange(index, "description", e.target.value)
                }
                sx={{ mb: 2 }}
              />

              {/* Quantity */}
              <TextField
                label="Quantity"
                type="number"
                fullWidth
                size="small"
                value={item.quantity}
                onChange={(e) =>
                  handleItemChange(index, "quantity", e.target.value)
                }
                onFocus={(e) => {
                  if (e.target.value === "0") {
                    e.target.value = "";
                  }
                }}
                onBlur={(e) => {
                  const val = parseFloat(e.target.value) || 0;
                  handleItemChange(index, "quantity", val.toString());
                }}
                error={!!itemFieldErrors[index]?.quantity}
                helperText={itemFieldErrors[index]?.quantity}
                sx={{ mb: 2 }}
              />

              {/* Unit */}
              <Autocomplete
                size="small"
                options={Array.isArray(unitOptions) ? unitOptions : []}
                getOptionLabel={(option) => {
                  if (!option) return "";
                  if (typeof option === "object") {
                    return option?.name || option?.unit_name || "";
                  }
                  const found = unitOptions.find(
                    (u) => String(u.id) === String(option),
                  );
                  return found?.name || "";
                }}
                value={
                  item.unit
                    ? unitOptions.find(
                        (u) => String(u.id) === String(item.unit),
                      ) || null
                    : null
                }
                onChange={(e, newValue) => {
                  handleInputChange(index, "unit", newValue);
                }}
                isOptionEqualToValue={(option, value) => {
                  if (!option && !value) return true;
                  if (!option || !value) return false;
                  const optionId =
                    typeof option === "object" ? option.id : option;
                  const valueId = typeof value === "object" ? value.id : value;
                  return String(optionId) === String(valueId);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="UOM"
                    size="small"
                    fullWidth
                    error={!!itemFieldErrors[index]?.unit}
                    helperText={itemFieldErrors[index]?.unit}
                    sx={{ mb: 2 }}
                  />
                )}
              />

              {/* Size */}
              <Autocomplete
                size="small"
                options={Array.isArray(sizeOptions) ? sizeOptions : []}
                getOptionLabel={(option) => {
                  if (!option) return "";
                  return option?.size || option?.name || "";
                }}
                value={
                  item.size
                    ? typeof item.size === "object"
                      ? item.size
                      : sizeOptions.find(
                          (s) => String(s.id) === String(item.size),
                        ) || null
                    : null
                }
                onChange={(e, newValue) => {
                  handleInputChange(index, "size", newValue);
                }}
                onInputChange={(e, newInputValue, reason) => {
                  if (reason === "input") {
                    handleItemInputChange(index, item, newInputValue, "size");
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  if (!option && !value) return true;
                  if (!option || !value) return false;
                  const optionId =
                    typeof option === "object" ? option.id : option;
                  const valueId = typeof value === "object" ? value.id : value;
                  return String(optionId) === String(valueId);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Product Type"
                    size="small"
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                )}
              />

              {/* Unit Price */}
              <TextField
                label="Unit Price"
                type="number"
                fullWidth
                size="small"
                value={item.rate}
                onChange={(e) =>
                  handleItemChange(index, "rate", e.target.value)
                }
                onBlur={(e) => {
                  const val = parseFloat(e.target.value) || 0;
                  handleItemChange(index, "rate", val.toString());
                }}
                error={!!itemFieldErrors[index]?.rate}
                helperText={itemFieldErrors[index]?.rate}
                sx={{ mb: 2 }}
              />

              {/* Amount */}
              <TextField
                label="Amount"
                type="number"
                fullWidth
                size="small"
                value={item.amount}
                onChange={(e) =>
                  handleItemChange(index, "amount", e.target.value)
                }
                sx={{ mb: 2 }}
              />

              {/* Total (Read-only) */}
              <TextField
                label="Total"
                fullWidth
                size="small"
                value={(
                  parseFloat(item.rate || 0) * parseFloat(item.quantity || 0)
                ).toFixed(2)}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiInputBase-input": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              />
            </Box>
          ))}

          {/* Add Item Button */}
          <Box textAlign="center" sx={{ mb: 3 }}>
            <Button
              variant="outlined"
              onClick={addItemRow}
              startIcon={<AddIcon />}
              fullWidth
            >
              Add Item
            </Button>
          </Box>

          {/* Grand Total */}
          <Box
            sx={{
              p: 2,
              border: "1px solid #ccc",
              borderRadius: "8px",
              backgroundColor: "#fff",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              <strong>Grand Total:</strong>
              <TextField
                value={formData.items
                  .reduce(
                    (sum, item) =>
                      sum +
                      parseFloat(item.rate || 0) *
                        parseFloat(item.quantity || 0),
                    0,
                  )
                  .toFixed(2)}
                size="small"
                disabled
                sx={{
                  width: "150px",
                  "& .MuiInputBase-input": {
                    fontWeight: "bold",
                    textAlign: "right",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      ) : (
        // ✅ DESKTOP VIEW - Table with Error Display
        <>
          <TableContainer sx={{ mt: 2 }}>
            <Box
              border="1px solid #ccc"
              borderRadius="8px"
              sx={{ mb: 3, p: 2, minWidth: 2100 }}
            >
              <Table>
                <TableHead>
                  <TableRow
                    sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}
                  >
                    <TableCell>S.No</TableCell>
                    <TableCell>Category</TableCell>
                    {/* <TableCell>Sub Category</TableCell> */}
                    <TableCell>Item</TableCell>
                    <TableCell>UOM</TableCell>
                    <TableCell>Product Type</TableCell>
                    <TableCell>Quantity</TableCell>
                    <TableCell>Unit Price</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {formData.items.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>
                        <Autocomplete
                          options={
                            Array.isArray(categories) ? categories : categories
                          }
                          getOptionLabel={(opt) => opt.name}
                          isOptionEqualToValue={(opt, val) =>
                            opt?.id === val?.id
                          }
                          value={item.category || null}
                          onChange={async (e, val, reason) => {
                            if (reason === "clear" || !val) {
                              await handleItemInputChange(
                                index,
                                item,
                                "",
                                "category",
                              );
                              handleInputChange(index, "category", null);
                              return;
                            }
                            handleInputChange(index, "category", val);
                          }}
                          onInputChange={(e, newValue, reason) => {
                            if (reason === "input") {
                              handleItemInputChange(
                                index,
                                item,
                                newValue,
                                "category",
                              );
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Category"
                              size="small"
                              sx={{ width: "180px" }}
                              required
                              error={!!itemFieldErrors[index]?.category}
                              helperText={itemFieldErrors[index]?.category}
                            />
                          )}
                        />
                      </TableCell>
                      {/* <TableCell>
                        <Autocomplete
                          options={subcategories[index] || []}
                          getOptionLabel={(opt) => opt.name}
                          isOptionEqualToValue={(opt, val) =>
                            opt?.subcat_id === val?.subcat_id
                          }
                          value={
                            (subcategories[index] || []).find(
                              (s) =>
                                s.subcat_id === item.sub_category?.subcat_id,
                            ) || null
                          }
                          onChange={async (e, val, reason) => {
                            if (reason === "clear" || !val) {
                              await handleItemInputChange(
                                index,
                                item,
                                "",
                                "sub_category",
                              );
                              handleInputChange(index, "sub_category", null);
                              return;
                            }
                            handleInputChange(index, "sub_category", val);
                          }}
                          onInputChange={(e, newValue) =>
                            handleItemInputChange(
                              index,
                              item,
                              newValue,
                              "sub_category",
                            )
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              sx={{ width: "180px" }}
                              label="Subcategory"
                              required
                              error={!!itemFieldErrors[index]?.sub_category}
                              helperText={itemFieldErrors[index]?.sub_category}
                            />
                          )}
                        />
                      </TableCell> */}
                      <TableCell>
                        <Autocomplete
                          options={
                            Array.isArray(itemOptions[index])
                              ? itemOptions[index]
                              : []
                          }
                          getOptionLabel={(opt) => opt.name}
                          isOptionEqualToValue={(opt, val) =>
                            opt?.id === val?.id
                          }
                          value={item.item}
                          onChange={async (e, val, reason) => {
                            if (reason === "clear" || !val) {
                              await handleItemInputChange(
                                index,
                                item,
                                "",
                                "item",
                              );
                              handleInputChange(index, "item", null);
                              return;
                            }
                            handleInputChange(index, "item", val);
                          }}
                          onInputChange={(e, newValue) =>
                            handleItemInputChange(index, item, newValue, "item")
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              size="small"
                              sx={{ width: "180px" }}
                              label="Item"
                              required
                              error={!!itemFieldErrors[index]?.item}
                              helperText={itemFieldErrors[index]?.item}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        {/* Unit Autocomplete */}
                        <Autocomplete
                          size="small"
                          options={unitOptions || []}
                          getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === "object") {
                              return option?.name || option?.unit_name || "";
                            }
                            // If option is ID, find matching unit
                            const found = unitOptions.find(
                              (u) => String(u.id) === String(option),
                            );
                            return found?.name || "";
                          }}
                          value={
                            item.unit
                              ? unitOptions.find(
                                  (u) => String(u.id) === String(item.unit),
                                ) || null
                              : null
                          }
                          onChange={(e, newValue) => {
                            handleInputChange(index, "unit", newValue);
                          }}
                          onInputChange={(e, newInputValue, reason) => {
                            // Only search when user is typing
                            if (reason === "input") {
                              // Add unit search if needed
                            }
                          }}
                          isOptionEqualToValue={(option, value) => {
                            if (!option && !value) return true;
                            if (!option || !value) return false;
                            const optionId =
                              typeof option === "object" ? option.id : option;
                            const valueId =
                              typeof value === "object" ? value.id : value;
                            return String(optionId) === String(valueId);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Unit"
                              size="small"
                              sx={{ width: "150px" }}
                              error={!!itemFieldErrors[index]?.unit}
                              helperText={itemFieldErrors[index]?.unit}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <Autocomplete
                          size="small"
                          options={
                            Array.isArray(sizeOptions) ? sizeOptions : []
                          }
                          getOptionLabel={(option) => {
                            if (!option) return "";
                            // return option?.size || option?.name || "";
                             return option?.type || option?.size || option?.name || "";
                          }}
                          value={
                            item.size
                              ? typeof item.size === "object"
                                ? item.size
                                : sizeOptions.find(
                                    (s) => String(s.id) === String(item.size),
                                  ) || null
                              : null
                          }
                          onChange={(e, newValue) => {
                            handleInputChange(index, "size", newValue);
                          }}
                          onInputChange={(e, newInputValue, reason) => {
                            if (reason === "input") {
                              handleItemInputChange(
                                index,
                                item,
                                newInputValue,
                                "size",
                              );
                            }
                          }}
                          isOptionEqualToValue={(option, value) => {
                            if (!option && !value) return true;
                            if (!option || !value) return false;
                            const optionId =
                              typeof option === "object" ? option.id : option;
                            const valueId =
                              typeof value === "object" ? value.id : value;
                            return String(optionId) === String(valueId);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              
                              label="Product Type"
                              size="small"
                              sx={{ width: "150px" }}
                            />
                          )}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="number"
                          value={item.quantity}
                          onChange={(e) =>
                            handleItemChange(index, "quantity", e.target.value)
                          }
                          onFocus={(e) => {
                            if (e.target.value === "0") {
                              e.target.value = "";
                            }
                          }}
                          onBlur={(e) => {
                            const val = parseFloat(e.target.value) || 0;
                            handleItemChange(index, "quantity", val.toString());
                          }}
                          style={{
                            width: "150px",
                            height: "36px",
                            padding: "8px",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            backgroundColor: "#fcfcfc",
                            border: itemFieldErrors[index]?.quantity
                              ? "1px solid red"
                              : "1px solid #c4c4c4",
                            boxSizing: "border-box",
                          }}
                        />
                        {itemFieldErrors[index]?.quantity && (
                          <div
                            style={{
                              color: "red",
                              fontSize: "0.8rem",
                              marginTop: "4px",
                            }}
                          >
                            {itemFieldErrors[index]?.quantity}
                          </div>
                        )}
                      </TableCell>
                      <TableCell>
                        <input
                          type="number"
                          value={item.rate}
                          onChange={(e) =>
                            handleItemChange(index, "rate", e.target.value)
                          }
                          onBlur={(e) => {
                            const val = parseFloat(e.target.value) || 0;
                            handleItemChange(index, "rate", val.toString());
                          }}
                          style={{
                            width: "150px",
                            padding: "8px",
                            height: "36px",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            backgroundColor: "#fcfcfc",
                            border: itemFieldErrors[index]?.rate
                              ? "1px solid red"
                              : "1px solid #c4c4c4",
                            boxSizing: "border-box",
                          }}
                        />
                        {itemFieldErrors[index]?.rate && (
                          <div
                            style={{
                              color: "red",
                              fontSize: "0.8rem",
                              marginTop: "4px",
                            }}
                          >
                            {itemFieldErrors[index]?.rate}
                          </div>
                        )}
                      </TableCell>

                      <TableCell>
                        <input
                          type="number"
                          value={item.amount}
                          onChange={(e) =>
                            handleItemChange(index, "amount", e.target.value)
                          }
                          style={{
                            width: "150px",
                            padding: "8px",
                            height: "36px",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            backgroundColor: "#fcfcfc",
                            border: "1px solid #c4c4c4",
                            boxSizing: "border-box",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="text"
                          readOnly
                          value={(
                            parseFloat(item.rate || 0) *
                            parseFloat(item.quantity || 0)
                          ).toFixed(2)}
                          style={{
                            width: "150px",
                            height: "36px",
                            padding: "8px",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            backgroundColor: "#fcfcfc",
                            border: "1px solid #c4c4c4",
                            boxSizing: "border-box",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        <input
                          type="text"
                          value={item.description}
                          onChange={(e) =>
                            handleItemChange(
                              index,
                              "description",
                              e.target.value,
                            )
                          }
                          style={{
                            width: "150px",
                            height: "36px",
                            padding: "8px",
                            fontSize: "0.875rem",
                            borderRadius: "4px",
                            backgroundColor: "#fcfcfc",
                            border: "1px solid #c4c4c4",
                            boxSizing: "border-box",
                          }}
                        />
                      </TableCell>

                      <TableCell>
                        <IconButton
                          onClick={() => deleteItemRow(index)}
                          color="error"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </TableContainer>

          <TableContainer>
            <Box sx={{ mb: 3, width: "100%" }}>
              <Table>
                <TableBody>
                  {/* Add Item Button */}
                  <TableRow>
                    <TableCell colSpan={9} align="center">
                      <Button
                        variant="outlined"
                        onClick={addItemRow}
                        startIcon={<AddIcon />}
                      >
                        Add Item
                      </Button>
                    </TableCell>
                  </TableRow>

                  {/* Grand Total Row */}
                  <TableRow>
                    <TableCell colSpan={9}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: 2,
                        }}
                      >
                        <strong>Grand Total</strong>
                        <TextField
                          value={formData.items
                            .reduce(
                              (sum, item) =>
                                sum +
                                parseFloat(item.rate || 0) *
                                  parseFloat(item.quantity || 0),
                              0,
                            )
                            .toFixed(2)}
                          size="small"
                          sx={{ width: "150px" }}
                          disabled
                        />
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </TableContainer>
        </>
      )}

      {/* Terms & Conditions */}
      <Box border="1px solid #ccc" borderRadius="8px" sx={{ mb: 3, p: 2 }}>
        <Typography variant="h6" gutterBottom>
          Terms & Conditions
        </Typography>

        {terms.map((term, index) => (
          <Grid
            container
            spacing={1}
            key={index}
            alignItems="center"
            sx={{ mb: 1 }}
          >
            <Grid item xs={5}>
              <TextField
                fullWidth
                placeholder="Term (e.g. Delivery Period)"
                value={term.key}
                onChange={(e) => handleTermChange(index, "key", e.target.value)}
                size="small"
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                placeholder="Value (e.g. Within 15 days)"
                value={term.value}
                onChange={(e) =>
                  handleTermChange(index, "value", e.target.value)
                }
                size="small"
              />
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => removeTerm(index)} color="error">
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
        <Dialog
          open={openItemModal}
          onClose={handleCloseItemModal}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle>Add Item</DialogTitle>
        </Dialog>
        <Button
          variant="outlined"
          sx={{ mt: 1 }}
          onClick={() =>
            setTerms([...terms, { key: "", value: "", is_default: false }])
          }
        >
          + Add Term
        </Button>
      </Box>
    </Box>
  );
}